import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

// Lazy Loaded Modules
const Bootcamp1Activities = dynamic(() => import('./Bootcamp1/Bootcamp1Activities'))

const PlanarFiguresActivities = (activityData: ActivityGroupProps): React.ReactElement => {
  const router = useRouter()
  const { moduleKey } = router.query
  switch (moduleKey) {
    case '1':
      return <Bootcamp1Activities {...activityData} />
    default:
      return <></>
  }
}

export default PlanarFiguresActivities
